import Cleave from 'cleave.js/react'
import { Props } from 'cleave.js/react/props'
import React from 'react'

/**
 * `Cleave` com `ref` normal. O pacote só expõe `htmlRef` (callback), então este
 * wrapper existe para que quem consome possa passar `ref` — de objeto ou de
 * função — como em qualquer input.
 *
 * Uso interno: quem aplica máscara é o `ui/input` quando recebe `options`.
 * Componente de tela não monta este aqui direto.
 */
export const CleaveTextField = React.forwardRef<any, Props>((props, ref) => {
    return (
        <Cleave
            {...props}
            htmlRef={el => {
                // Handle object refs (useRef)
                if (ref && 'current' in ref) {
                    ref.current = el
                }
                // Handle legacy function refs
                else if (typeof ref === 'function') {
                    ref(el)
                }
            }}
        />
    )
})
